import { CareOfEnum, DischargeLocationEnum, type DischargePlanViewModel } from '@generated';
import { SectionCard } from '~/shared/section/SectionCard';
import { EstimatedDischargeDate } from './EstimatedDischargeDate';

export function DischargePlan({ dischargePlan, estimatedDischargeDate }: { dischargePlan: DischargePlanViewModel; estimatedDischargeDate?: Date }) {
	return (
		<div className="grid grid-cols-1 gap-3">
			<div className="grid grid-cols-3 gap-5">
				<EstimatedDischargeDate dischargePlan={dischargePlan} estimatedDischargeDate={estimatedDischargeDate} />
				<SectionCard
					title="Discharge Location"
					value={dischargePlan.dischargeLocationLabel}
					description={
						dischargePlan.dischargeLocationId === DischargeLocationEnum.Facility && dischargePlan.dischargeToFacility
							? dischargePlan.dischargeToFacility.name
							: dischargePlan.dischargeLocationId === DischargeLocationEnum.Other
							? dischargePlan.otherLocation
							: undefined
					}
				/>
				<SectionCard
					title="Discharge To Care Of"
					value={dischargePlan.careOfLabel}
					description={
						dischargePlan.careOfId === CareOfEnum.Caregiver && dischargePlan.dischargeToCaregiver
							? dischargePlan.dischargeToCaregiver.name
							: dischargePlan.careOfId === CareOfEnum.Physician && dischargePlan.dischargeToPhysician
							? dischargePlan.dischargeToPhysician.fullName
							: undefined
					}
				/>
				<div className="col-span-3">
					<SectionCard title="Discharge Goal" value={dischargePlan.patientDischargeGoal ?? 'N/A'} />
				</div>
				<div className="col-span-3">
					<SectionCard title="Additional Notes">
						<p className="text-sm leading-relaxed text-gray-700">
							{dischargePlan.notes || 'No additional notes provided for this discharge plan.'}
						</p>
					</SectionCard>
				</div>
			</div>
		</div>
	);
}
